import { useState } from "react";
import { searchQuestions, pad } from "../../qa";
import styles from "./Search.module.css";

const MAX_SHOWN = 40;

export default function Search({ onPick }) {
  const [query, setQuery] = useState("");
  const results = searchQuestions(query);

  function pick(q) {
    onPick(q);
    setQuery("");
  }

  return (
    <div className={styles.search} role="search">
      <label className={styles.field}>
        <span className={styles.icon} aria-hidden="true">⌕</span>
        <input
          className={styles.input}
          type="search"
          value={query}
          placeholder="SEARCH QUESTIONS..."
          aria-label="Search all 150 questions"
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Escape") setQuery("");
            if (e.key === "Enter" && results[0]) pick(results[0]);
          }}
        />
      </label>
      {query.trim() && (
        <div className={styles.results}>
          <p className={styles.count}>
            {results.length} {results.length === 1 ? "RESULT" : "RESULTS"}
            {results.length > MAX_SHOWN ? ` / SHOWING ${MAX_SHOWN}` : ""}
          </p>
          <ul className={styles.list}>
            {results.slice(0, MAX_SHOWN).map((q) => (
              <li key={q.id}>
                <button type="button" className={styles.hit} onClick={() => pick(q)}>
                  <span className={styles.hitId}>{q.id}</span>
                  <span className={styles.hitText}>{q.text}</span>
                  <span className={styles.hitMeta}>
                    SET {pad(q.set)} / {q.difficulty}
                  </span>
                </button>
              </li>
            ))}
          </ul>
          {results.length === 0 && <p className={styles.empty}>NO MATCHES</p>}
        </div>
      )}
    </div>
  );
}
